/**
 * Top bar for the editor — deck title, project link, theme, "open
 * standalone" link to the SSO+invite-gated public preview.
 */

import { Link } from "react-router-dom";

import type { Deck } from "../types";
import { SignOutButton } from "./SignOutButton";

interface DeckEditorTopBarProps {
  deck: Deck;
}

export function DeckEditorTopBar({ deck }: DeckEditorTopBarProps) {
  const previewUrl = `/api/decks/${deck.id}/preview`;
  return (
    <header style={barStyle} data-testid="deck-editor-topbar">
      <div style={{ display: "flex", alignItems: "baseline", gap: "0.75rem" }}>
        <Link
          to="/decks"
          style={{
            color: "var(--gray-9)",
            textDecoration: "none",
            fontSize: "0.85em",
          }}
        >
          ← Decks
        </Link>
        <h1 style={titleStyle}>{deck.title}</h1>
        <span style={metaStyle}>
          <code>{deck.slug}</code>
        </span>
        <span style={metaStyle}>{deck.theme}</span>
        <span style={metaStyle}>
          {deck.deck_json.slides.length} slides
        </span>
        <span style={metaStyle}>v{deck.version}</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <a
          href={previewUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={linkBtnStyle}
          data-testid="deck-open-standalone"
        >
          Open standalone preview
        </a>
        <SignOutButton />
      </div>
    </header>
  );
}

const barStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0.5rem 0.9rem",
  borderBottom: "1px solid var(--gray-5)",
  background: "var(--gray-2)",
  flex: "0 0 auto",
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontSize: "1.05em",
  fontWeight: 600,
};

const metaStyle: React.CSSProperties = {
  color: "var(--gray-9)",
  fontSize: "0.85em",
};

const linkBtnStyle: React.CSSProperties = {
  fontSize: "0.85em",
  color: "var(--accent-11)",
  textDecoration: "none",
  padding: "0.25rem 0.55rem",
  borderRadius: 4,
  background: "var(--accent-3)",
  border: "1px solid var(--accent-7)",
};
